import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_automations_url } from '@/utils/urls.ts';
import { useNavigate } from 'react-router-dom';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AUTOMATIONS_KEY } from '@/utils/queryKeys.ts';
import { useOrgProject } from '@/context/OrgProjectContext/useOrgProject.ts';
import { Automation } from '@/types/automations.ts';

type CreateAutomationParams = {
  name: string;
  description?: string;
};

const useCreateAutomation = (): UseMutationResult<
  Automation,
  AxiosError,
  CreateAutomationParams
> => {
  const apiClient = useApiClient();
  const { projectId } = useOrgProject();

  const queryClient = useQueryClient();

  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (newAutomation: CreateAutomationParams) => {
      const response = await apiClient.post(get_automations_url(projectId), newAutomation);
      return response.data;
    },
    onSuccess: async (automation: Automation) => {
      await queryClient.invalidateQueries({ queryKey: AUTOMATIONS_KEY });
      navigate(`/automations/${automation.id}/editor`);
    },
  });
};

export default useCreateAutomation;
